/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./listGrants.defs.js";
export { main as default } from "./listGrants.defs.js";
